import React from 'react';
import { Link } from 'react-router-dom';
import styles from './item.module.scss';

type Props = {
  key?: number,
  studio: IStudioItem
};

const StudioItem: React.FC<Props> = ({ studio }) => {
  const studioLink = `/studio/${studio.slug}`;

  return (
    <div className={styles.studioItem}>
      <div className={styles.imageContainer}>
        <div className={styles.image}>
          <img src={studio.image} alt={studio.title} />
        </div>
        <div className={styles.detailsLink}>
          <Link to={studioLink}>
            <span className={styles.title}>{studio.title} <i className="fa fa-chevron-left" /></span>
          </Link>
        </div>
      </div>
      <div className={styles.info}>
        <h4 className={styles.title}><Link to={studioLink}><i className="fa fa-map-marker-alt" /> {studio.address}</Link></h4>
        <p className={styles.summary}>
          {studio.summary}
        </p>
      </div>
    </div>
  );
}

export default StudioItem;
